import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    // Force account selection every time
    provider.setCustomParameters({
        prompt: 'select_account'
    });

    try {
      const result = await signInWithPopup(auth, provider);
      await handleLoginSuccess(result.user);
      navigate('/');
    } catch (error) {
      console.error('Error signing in with Google:', error);
      setError(error.message);
    }
  };

  const handleLoginSuccess = async (user) => {
    try {
      // Call the user-login endpoint to update context
      await fetch(`${process.env.REACT_APP_AI_ENDPOINT_URL}/user-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'User-Email': user.email
        }
      });

      console.log("Context updated on login");
    } catch (error) {
      console.error("Error updating context on login:", error);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
    </div>;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-500 to-indigo-600">
      <div className="px-8 py-6 text-left bg-white shadow-lg rounded-lg">
        <h3 className="text-2xl font-bold text-center text-gray-800 mb-4">Welcome to Mednavigator AI</h3>
        <p className="text-center text-gray-600 mb-8">Please sign in to continue</p>
        {error && <p className="text-red-500 text-sm mt-2 text-center">{error}</p>}
        <button
          onClick={handleGoogleSignIn}
          className="w-full px-4 py-2 text-white bg-blue-600 rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-200 ease-in-out transform hover:-translate-y-1 hover:shadow-lg"
        >
          Sign in with Google
        </button>
        <p className="text-center text-xs text-gray-400 mt-6">
          <a href="/privacy-policy" className="hover:text-gray-600 underline">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
